<template>
  <div class="skeleton-loading skeleton-shimmer rounded-md" role="status" aria-label="Loading content" />
</template>

<style scoped>
/* Base skeleton styles */
.skeleton-loading {
  display: block;
  min-height: 20px;
  min-width: 60px;
  background-color: #f3f4f6;
  position: relative;
  overflow: hidden;
}

/* Shimmer/Wave Effect */
.skeleton-shimmer {
  background: linear-gradient(
    90deg,
    #f3f4f6 0%,
    #e5e7eb 20%,
    #d1d5db 50%,
    #e5e7eb 80%,
    #f3f4f6 100%
  );
  background-size: 200% 100%;
  animation: shimmer 2s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
